import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'retailers-retailer_on_choose_option_from_quicker_add-click';

/**
 * this event fires when retailer click choose multi option using quicker quick add
 */
export function trackRetailersRetailerOnChooseOptionFromQuickerAddClick(
  retailerToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { retailerToken },
  });
}
